import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const BarChart = ({ chartData, chartOptions, height, width }) => {
  const [data, setData] = useState([]);
  const [options, setOptions] = useState({});


  useEffect(() => {
    setData(chartData);
    setOptions(chartOptions);
  }, [chartData, chartOptions]);

  return (
    <ReactApexChart
      options={options}
      series={data}
      type="bar"
      height={height}
      width={width}
    />
  );
};

export default BarChart;
